





































import Vue from "vue";

export default Vue.extend({
    props: {
        installationName: String,
        machineSerialNumber: String,
        showDialog: Boolean,
        challengeCode: String,
    },
    data() {
        return { canCopy: window.isSecureContext, copiedToClipboard: false };
    },
    computed: {
        showConfirmSmartLockEnablingDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
            },
        },
    },
    methods: {
        enableSmartLock() {
            this.$emit("enabled");
            this.showConfirmSmartLockEnablingDialog = false;
        },
        cancelPressed() {
            this.showConfirmSmartLockEnablingDialog = false;
        },
        async copyChallengeCode() {
            await navigator.clipboard.writeText(this.challengeCode);
            this.copiedToClipboard = true;
            setTimeout(() => {
                this.copiedToClipboard = false;
            }, 1500);
        },
    },
});
